// Where the browser sends /api calls. One variable — VITE_ADMIN_API_BASE_URL,
// held in Infisical — reaching the page by two routes, in this precedence:
//
//   1. window.__ADMIN_CONFIG__ — RUNTIME. server.mjs serves /config.js from
//      VITE_ADMIN_API_BASE_URL in the container's environment. This is the
//      production path, and it is what lets one image run against staging and
//      production, so it must win over anything compiled in.
//
//   2. import.meta.env.VITE_ADMIN_API_BASE_URL — BUILD TIME, read from the dev
//      shell (npm run admin:dev runs under infisical run). The Docker build runs
//      with no environment, so it compiles to undefined there.
//
// Empty means same origin, which is only ever right in dev. In a container it
// means the variable never arrived — server.mjs warns loudly about that on boot.
const runtimeValue = window.__ADMIN_CONFIG__?.apiBaseUrl
const buildTimeValue = import.meta.env.VITE_ADMIN_API_BASE_URL

// Keeps `vite dev` working before the variable reaches Infisical.
// import.meta.env.DEV is false in every production build, so this cannot leak
// into the image.
const devFallback = import.meta.env.DEV ? 'http://localhost:8080' : ''

export const API_BASE_URL = runtimeValue || buildTimeValue || devFallback
